
import React from 'react';
import LeagueTable from '@/components/league/LeagueTableView';
import Header from '@/components/layout/Header';

interface TableDisplayProps {
  tableData: any[];
  filteredAndSortedData: any[];
  onSort: (column: string) => void;
  sortColumn: string | null;
  sortDirection: 'asc' | 'desc';
  selectedCountry: string;
  selectedLeague: string;
  selectedYear: string;
}

const TableDisplay: React.FC<TableDisplayProps> = ({
  tableData,
  filteredAndSortedData,
  onSort,
  sortColumn,
  sortDirection,
  selectedCountry,
  selectedLeague,
  selectedYear,
}) => {
  return (
    <>
      <Header />
      <div className="container mx-auto">
        <LeagueTable 
          data={tableData} 
          filteredAndSortedData={filteredAndSortedData} 
          onSort={onSort} 
          sortColumn={sortColumn} 
          sortDirection={sortDirection} 
          selectedCountry={selectedCountry} 
          selectedLeague={selectedLeague} 
          selectedYear={selectedYear} 
        />
      </div>
    </>
  );
};

export default TableDisplay;
